import { render, staticRenderFns } from "./chooseCommandCenter.vue?vue&type=template&id=0a8e3bfc&scoped=true"
import script from "./chooseCommandCenter.vue?vue&type=script&lang=js"
export * from "./chooseCommandCenter.vue?vue&type=script&lang=js"
import style0 from "./chooseCommandCenter.vue?vue&type=style&index=0&id=0a8e3bfc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a8e3bfc",
  null
  
)

export default component.exports